exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".style__buttons___1uG4P{display:flex;flex-direction:row;align-items:center;justify-content:flex-end}.style__input-wrapper___1l4Ej{margin-bottom:15px}.style__run-immediately___qdyqK{font-size:13px;font-weight:normal;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;color:#557eff;margin-left:10px}\n", ""]);

// Exports
exports.locals = {
	"buttons": "style__buttons___1uG4P",
	"input-wrapper": "style__input-wrapper___1l4Ej",
	"run-immediately": "style__run-immediately___qdyqK"
};